import type { Implementation } from "#public"
import type { MessageRouter } from "#public"
import type { ReceiverInput } from "#public"
import type { ReceiverOutput } from "#public"

export const RequestHandler = <T, R>(
  func: Implementation<T, R>,
  forward?: MessageRouter<T, R>
): MessageRouter<T, R> => {
  const router = (request: ReceiverInput<T>): ReceiverOutput<R> => func(request, forward ?? router)
  return router
}
